// extracted by mini-css-extract-plugin
export default {"container":"tK-z","dimension":"uK-z","dimensionLabels":"vK-z"};